import type { MessagesService } from './index';
import { ReplaySubject } from 'rxjs';
import { injectable } from 'src/features/ioc';
import type { Message } from 'src/routes/widgets/MessagesWidget/types';

@injectable()
export class MessagesServiceImpl implements MessagesService {
    messagesReceivedSubject$ = new ReplaySubject<Message>();
}
